import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
import { TreeViewDataItem } from "../../../components/cpm/DocumentPartTree";

const downloadDocumentCopySlice = createSlice({
  name: "downloadDocumentCopy",
  initialState: { document: null as TreeViewDataItem | null },

  reducers: {
    // your reducers here
    setDocumentToDownload: (state, action: PayloadAction<{ document: TreeViewDataItem }>) => {
      state.document = action.payload?.document;
      console.log(state);
    },
  },
});

export const documentToDownload = (state: RootState) => state.downloadDocumentCopy.document;
export const { setDocumentToDownload } = downloadDocumentCopySlice.actions;

export default downloadDocumentCopySlice.reducer;
